import { render, staticRenderFns } from "./CollapsablePanel.vue?vue&type=template&id=5bf019e8&scoped=true&"
import script from "./CollapsablePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsablePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsablePanel.vue?vue&type=style&index=0&id=5bf019e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf019e8",
  null
  
)

export default component.exports